<template>
    <div>
        <el-dialog
            append-to-body
                :fullscreen="dialogFull"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                :before-close="handleClose"
                :visible.sync="dialogShow"
                v-if="dialogShow"
                width="50%"
            :modal-append-to-body="false">
            <template slot="title">
            <div class="avue-crud__dialog__header">
                    <span class="el-dialog__title">
                            催 办
                    </span>
                    <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                    
            </div>
            <el-divider></el-divider>
    </template>
            <avue-form 
                :option="urgeOption"
                v-model="form"
                @submit="formSubmit"
                @error="formError">
                 <template slot="remark">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入 备注"
                                v-model="form.remark">
                            </el-input>
                            <remarkModel :remark.sync="form.remark" ref="scrapFormRemarkModel"></remarkModel>
                        </div>
                    </template>
               
                <template slot="menuForm">
                    <el-button @click="handleClose" ><span class="el-icon-close"></span> 取消</el-button>
                </template>
            </avue-form>
        </el-dialog>
    </div>
</template>
<script>
import {
  
    urgeOption,
} from "./course-dialog-form-option";
import remarkModel from "./remark-model";
import { getGroupDetails,getCooperateList,setCooperate,urge } from "@/api/gateservice/order/order-list/order-list";
export default {
    components:{
        remarkModel
    },
    data(){
        return{
            dialogFull:false,
            form:{
                orderId:'',
                remark:'',
            },
            cheackedPeople:[],
            userList:[],
            dialogShow:false,
            urgeOption:urgeOption
        }
    },
    created(){
        
    },
    methods:{
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取 消',
                        type: 'warning',
                })
                .then(()=> {
                        
                        self.dialogShow = false;
                        
                })
                .catch(()=> {
                        
                });
        },
        openDialog(orderId){
            this.dialogShow = true;
            console.log("openDialog")
            this.form = {
                orderId:orderId
            }
        },
        closeDialog(){
            this.dialogShow = false;
        },
        formSubmit(form,done){
         console.log("formSubmit=================>",form)
            let temForm = {};
            temForm.orderId = form.orderId;
            temForm.remark = form.remark
            urge(temForm).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                     this.dialogVisible = false;
                     this.dialogShow = false;
                }else{
                    this.$message.error(res.msg);
                }
                this.$emit('handleClose',function(){console.log('关闭历程表')})
                
                this.dialogShow = false;
                done()
            }).catch(err=>{
                
                
                done()
            })
        },
    }
}
</script>




    // <el-dialog
    //   title="催办"
    //   :visible.sync="dialogOrderPressingBoxVisible"
    //   append-to-body
    // >
    //   <el-form label-width="100px" v-if="dialogOrderPressingBoxVisible">

    //     <el-form-item label="备注">
    //       <el-input
    //         type="textarea"
    //         v-model="orderPressingForm.remark"
    //       ></el-input>
    //       <remarkModel
    //         :remark.sync="orderPressingForm.remark"
    //         ref="orderPressingFormRemarkModel"
    //       ></remarkModel>
    //     </el-form-item>

    //     <el-form-item label="" required>

    //     </el-form-item>
    //     <el-form-item>
    //       <el-button type="primary" @click="submitOrderPressingForm">
    //         保存
    //       </el-button>
    //       <el-button @click="dialogOrderPressingBoxVisible = false">
    //         取消
    //       </el-button>
    //     </el-form-item>
    //   </el-form>
    // </el-dialog>